import React, { Component } from "react";
import { Link } from "react-router-dom";
import MapContainer from "./mapcontainer";
import { Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,Container } from "reactstrap";
class TrackVehicle extends Component {
  render() {
    return (
      <div>
         {this.props.location.data.children}
        <div style={{display: 'flex', justifyContent: 'center'}}  className="header bg-gradient-info pt--8 " fluid>
          <Container fluid>
            <div className="header-body">
            {/*   <Row>
                <Col md={10}></Col>
                <Col md={2} className="pb-2">
                  <Link className="btn btn-secondary" to="/">
                    Back
                  </Link>
                </Col>
              </Row> */}
              <MapContainer selectedVechile={this.props} />
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default TrackVehicle;
